import { isEmpty } from 'lodash';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  onGetWaitingList: (data) => ({ data }),
  onPTJoinRoom: (data, isJoin = true, isCurrentPT) => ({
    data,
    isJoin,
    isCurrentPT,
  }),
  onRemovePT: (data, shouldRemove = true, isCurrentPT) => ({
    data,
    shouldRemove,
    isCurrentPT,
  }),
  setState: (state, value) => ({ state, value }),
  updateLocalStream: (streams) => ({ streams }),
  updateRemoteStream: (streams) => ({ streams }),
  cancelConsult:
    () =>
    async ({ Api, customToast, getState }) => {
      let { callId } = getState().waitingRoom;
      let { status } = await Api.put(`calls/${callId}/cancellation`);
      if (status === 200) {
        customToast('success', 'Cancel Success');
      }
    },
  completeConsult:
    () =>
    async ({ Api, customToast, getState }) => {
      let { callId } = getState().waitingRoom;
      let { status } = await Api.put(`calls/${callId}/completion`);
      if (status === 200) {
        customToast('success', 'Complete Success');
      }
    },
  checkVerify:
    () =>
    async ({ getState }) => {
      let { verifyingUserData } = getState().waitingRoom;
      if (!isEmpty(verifyingUserData))
        waitingRoomDispatcher.setState('verifyModalVisibility', true);
    },
  clearWaitingList: (payload) => ({ payload }),
  getMemberAppointment:
    (userId, cb) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(
        `doctor-appointments/members/${userId}`
      );
      cb && cb();
      if (status === 200) {
        waitingRoomDispatcher.getMemberAppointmentSuccess(result || []);
      } else waitingRoomDispatcher.getMemberAppointmentSuccess([]);
    },
  getMemberAppointmentSuccess: (data) => ({ data }),
  resetState: () => ({}),
  checkConsultPending:
    (cb) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`consultations/pending`);
      status === 200 && cb(result);
    },
  getSummarySoap:
    (callHistoryId, onSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(
        `consultations/${callHistoryId}/soap`
      );
      status === 200 && onSuccess(result);
    },
  updateSummarySoap:
    (callHistoryId, params, onSuccess) =>
    async ({ Api }) => {
      const { soapText, consultInfoText } = params;
      const { status } = await Api.put(`consultations/${callHistoryId}/soap`, {
        soapText,
        consultInfoText,
      });
      status === 200 && onSuccess();
    },
  addMessage: (context) => ({
    ...context,
  }),
};

const waitingRoomDispatcher = synthesize('waitingRoom', mapDispatchToAC);
export default waitingRoomDispatcher;
